const selectZones = state => state.data.zones

const ZoneDataStoreSelectors = {
  zones: selectZones
}

export default ZoneDataStoreSelectors
